let ctx
export default function (context) {
    ctx = context
    return [
        {
            id: "messageText",
            next: "firstname",
            body: "Hallo, wie kann ich dir helfen?\nStell mir gerne deine Frage oder schreibe mir eine Nachricht!",
            inputLabel: "Nachricht",
            inputType: "text",
            defaultData: function () {
                return ctx.messageText
            },
            hide: function () {
                return !!ctx.messageText
            },
            defaultValue: function () {
                return ctx.currentMessage
            },
        },
        {
            id: "firstname",
            next: "lastname",
            body: "Verrätst du mir deinen Vornamen, damit ich dir antworten kann?",
            inputLabel: "Dein Vorname",
            inputType: "text",
            defaultData: function () {
                return ctx.$auth.user?.firstname
            },
            hide: function () {
                return !!ctx.$auth.user?.firstname
            },
        },
        {
            id: "lastname",
            next: null,
            body: "Wie lautet dein Nachname?",
            inputLabel: "Dein Nachname",
            inputType: "text",
            defaultData: function () {
                return ctx.$auth.user?.lastname
            },
            hide: function () {
                return !!ctx.$auth.user?.firstname
            },
        },
    ]
}
